module.exports = __webpack_public_path__ + "static/img/close_arrow_icon.383a21e6.svg";